import styled, { css } from 'styled-components';
import theme from 'src/theme';

export type BannerVariant = 'critical' | 'warning' | 'information';

const VARIANT_STYLES: Record<BannerVariant, ReturnType<typeof css>> = {
    critical: css`
        background: ${theme.colors.banner.critical.bg};
        border-bottom: 1px solid ${theme.colors.banner.critical.border};
        color: ${theme.colors.banner.critical.text};
    `,
    warning: css`
        background: ${theme.colors.banner.warning.bg};
        border-bottom: 1px solid ${theme.colors.banner.warning.border};
        color: ${theme.colors.banner.warning.text};
    `,
    information: css`
        background: ${theme.colors.banner.information.bg};
        border-bottom: 1px solid ${theme.colors.banner.information.border};
        color: ${theme.colors.banner.information.text};
    `,
};

export interface BannerStripProps {
    message: string;
    variant: BannerVariant;
    onDismiss?: () => void;
    dismissAriaLabel?: string;
    role?: React.AriaRole;
}

export const BannerStrip: React.FC<BannerStripProps> = ({
    message,
    variant,
    onDismiss,
    dismissAriaLabel = 'Dismiss banner',
    role,
}) => (
    <BannerWrapper $variant={variant} role={role}>
        <BannerText>{message}</BannerText>
        {onDismiss && (
            <DismissButton onClick={onDismiss} aria-label={dismissAriaLabel}>
                ✕
            </DismissButton>
        )}
    </BannerWrapper>
);

const BannerWrapper = styled.div<{ $variant: BannerVariant }>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    position: relative;
    ${({ $variant }) => VARIANT_STYLES[$variant]}
`;

const BannerText = styled.span`
    font-size: 14px;
    font-weight: 500;
`;

const DismissButton = styled.button`
    position: absolute;
    right: 16px;
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    padding: 4px 8px;
    color: inherit;

    &:hover {
        opacity: 0.7;
    }
`;
